import { message } from 'antd';

export const FlashMessageHelper = {
   error: (text: string) => {
      message.error(text, 2.5);
   },
   success: (text: string) => {
      message.success(text, 2.5);
   }
}